module.exports = __webpack_public_path__ + "img/a_e5.0fd5834c.png";